module.exports = __webpack_public_path__ + "img/24.2a57ed04.jpg";